export class ListaPrecio {
  id?: number;
  nombre: string;
  code: string;
  articulos: any[];
  estado: string;
  description: string;
  observacion: string;
  perfil : [];
  desde: string;
  hasta: string;
  incluirIva?: boolean;
  incluirImpuestosInternos?: boolean;
}
